import { c as _c } from "react/compiler-runtime";
import './text-area.scss';
import { type TextareaHTMLAttributes, useState } from 'react';
import type { FieldProps } from '../field/field.tsx';
import { Field, FieldErrorMessage, FieldWrapper, getErrorElId } from '../field/field.tsx';
export type TextAreaProps = {
  'aria-labelledby'?: React.ComponentPropsWithoutRef<'textarea'>['aria-labelledby'];
  'aria-label'?: string;
  label?: string;
  name?: string;
  className?: string;
  placeholder?: string;
  defaultValue?: string;
  onChange?: TextareaHTMLAttributes<HTMLTextAreaElement>['onChange'];
  textareaRef?: React.MutableRefObject<HTMLTextAreaElement>;
  maxLength?: number;
  rows?: number;
  helpText?: string;
};
export const TextArea: React.FC<TextAreaProps> = t0 => {
  const $ = _c(25);
  let defaultValue;
  let fieldProps;
  let helpText;
  let label;
  let maxLength;
  let name;
  let onChange;
  let placeholder;
  let rows;
  let textareaRef;
  if ($[0] !== t0) {
    ({
      label,
      name,
      placeholder,
      defaultValue,
      onChange,
      textareaRef,
      maxLength,
      rows,
      helpText,
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = defaultValue;
    $[2] = fieldProps;
    $[3] = helpText;
    $[4] = label;
    $[5] = maxLength;
    $[6] = name;
    $[7] = onChange;
    $[8] = placeholder;
    $[9] = rows;
    $[10] = textareaRef;
  } else {
    defaultValue = $[1];
    fieldProps = $[2];
    helpText = $[3];
    label = $[4];
    maxLength = $[5];
    name = $[6];
    onChange = $[7];
    placeholder = $[8];
    rows = $[9];
    textareaRef = $[10];
  }
  const [charCount, setCharCount] = useState(defaultValue?.length || 0);
  const t1 = fieldProps as FieldProps;
  const t2 = name ?? "";
  let t3;
  if ($[11] !== charCount || $[12] !== defaultValue || $[13] !== helpText || $[14] !== label || $[15] !== maxLength || $[16] !== onChange || $[17] !== placeholder || $[18] !== rows) {
    t3 = t4 => {
      const {
        controlProps,
        error,
        formMethods
      } = t4;
      const errorElId = getErrorElId(controlProps.id);
      const handleValueChange = e => {
        setCharCount(e.target.value.length);
        formMethods?.setValue(controlProps.name as string, e.target.value, {
          shouldValidate: true
        });
        if (!onChange) {
          return;
        }
        onChange(e);
      };
      return <>{label && <label className="form-label label" htmlFor={controlProps.id}>{label}</label>}<FieldWrapper><div className="flex flex-col w-full"><textarea className="TextArea form-control" rows={rows} maxLength={maxLength} placeholder={placeholder} {...controlProps} {...error && {
              "aria-errormessage": errorElId
            }} onChange={handleValueChange} defaultValue={defaultValue || ""} />{maxLength != null && <span className="TextArea__char-count label-sm flex justify-end" aria-live="polite" aria-atomic="true">{`${charCount}/${maxLength}`}</span>}</div>{helpText && <em className="block label-sm label-subtle mt-snug-lg">{helpText}</em>}<FieldErrorMessage error={error} id={errorElId} /></FieldWrapper></>;
    };
    $[11] = charCount;
    $[12] = defaultValue;
    $[13] = helpText;
    $[14] = label;
    $[15] = maxLength;
    $[16] = onChange;
    $[17] = placeholder;
    $[18] = rows;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== textareaRef) {
    t4 = <Field {...t1} name={t2} controlRef={textareaRef}>{t3}</Field>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = textareaRef;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
};